// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-components-bot-semi-src-components-ui-pagination-index-module__ui-pagination-jHAVsc {
  justify-content: center;
  align-items: center;
  padding-right: 150px;
  display: flex;
  position: relative;
}

.\\------packages-components-bot-semi-src-components-ui-pagination-index-module__ui-pagination-jHAVsc .\\------packages-components-bot-semi-src-components-ui-pagination-index-module__change-button-_Tt4on {
  color: var(--light-usage-text-color-text-2, rgba(28, 29, 35, .6));
  padding: 6px;
  font-size: 12px;
  line-height: 16px;
}

.\\------packages-components-bot-semi-src-components-ui-pagination-index-module__ui-pagination-jHAVsc .\\------packages-components-bot-semi-src-components-ui-pagination-index-module__page-text-o0PcGp {
  width: 150px;
  color: var(--light-usage-text-color-text-2, rgba(28, 29, 35, .6));
  font-size: 12px;
  line-height: 16px;
  position: absolute;
  right: -26px;
}

.\\------packages-components-bot-semi-src-components-ui-pagination-index-module__ui-pagination-jHAVsc .\\------packages-components-bot-semi-src-components-ui-pagination-index-module__page-text-o0PcGp .\\------packages-components-bot-semi-src-components-ui-pagination-index-module__size-info-DrX6gU {
  align-items: center;
  display: flex;
}

.\\------packages-components-bot-semi-src-components-ui-pagination-index-module__ui-pagination-jHAVsc .semi-page-item {
  color: var(--light-usage-text-color-text-2, rgba(28, 29, 35, .6));
  font-size: 12px;
  line-height: 16px;
}

.\\------packages-components-bot-semi-src-components-ui-pagination-index-module__ui-pagination-jHAVsc .semi-page-item-active {
  color: var(--light-usage-text-color-text-0, #1c1d23);
  background-color: #fff;
  border: .5px solid rgba(28, 31, 35, .16);
  border-radius: 4px;
}

.\\------packages-components-bot-semi-src-components-ui-pagination-index-module__ui-pagination-jHAVsc .semi-page-item-active:hover {
  color: var(--light-usage-text-color-text-0, #1c1d23);
  background-color: #fff;
  border: .5px solid rgba(28, 31, 35, .16);
  border-radius: 4px;
}

.\\------packages-components-bot-semi-src-components-ui-pagination-index-module__ui-pagination-jHAVsc .semi-page-item-disabled .semi-icon {
  color: rgba(28, 31, 35, .2);
}

.\\------packages-components-bot-semi-src-components-ui-pagination-index-module__ui-pagination-jHAVsc .semi-page-item:hover {
  border-radius: 4px;
  border: 1px solid var(--light-usage-focus-color-focus-border, #4062ff) !important;
}

.\\------packages-components-bot-semi-src-components-ui-pagination-index-module__ui-pagination-jHAVsc .semi-page-prev:hover {
  background-color: rgba(102, 204, 255, 0);
  border-color: rgba(0, 0, 0, 0) !important;
}

.\\------packages-components-bot-semi-src-components-ui-pagination-index-module__ui-pagination-jHAVsc .semi-page-next:hover {
  background-color: rgba(102, 204, 255, 0);
  border-color: rgba(0, 0, 0, 0) !important;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-pagination": `------packages-components-bot-semi-src-components-ui-pagination-index-module__ui-pagination-jHAVsc`,
	"uiPagination": `------packages-components-bot-semi-src-components-ui-pagination-index-module__ui-pagination-jHAVsc`,
	"change-button": `------packages-components-bot-semi-src-components-ui-pagination-index-module__change-button-_Tt4on`,
	"changeButton": `------packages-components-bot-semi-src-components-ui-pagination-index-module__change-button-_Tt4on`,
	"page-text": `------packages-components-bot-semi-src-components-ui-pagination-index-module__page-text-o0PcGp`,
	"pageText": `------packages-components-bot-semi-src-components-ui-pagination-index-module__page-text-o0PcGp`,
	"size-info": `------packages-components-bot-semi-src-components-ui-pagination-index-module__size-info-DrX6gU`,
	"sizeInfo": `------packages-components-bot-semi-src-components-ui-pagination-index-module__size-info-DrX6gU`
};
export default ___CSS_LOADER_EXPORT___;
